module.exports = "/img/_/_/_/assets/images/icon//ranking.png?5671cb1ece99de412379df52639eecfd";